import Game from "./Game.js";
import AContainer from "../../library/ExtendedObjects/AContainer.js";
import gameData from "../../gameData.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Game_UnlockedPopup extends AContainer
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        super(scene);
        this.scene = scene;

        this.overlay = this.create(0, 0, "bg_forest");
        this.overlay.tint = 0x000000;
        this.overlay.setInteractive();

        this.emitter = this.scene.add.particles(this.scene.defaultAtlas, 'SnakeParticle').createEmitter({
            tint: [0xff0000, 0x00ff00],
            scale: { start: .8, end: 0 },
            speed: {min: -300, max: 300 },
            quantity: 200
        });
        this.emitZone = {
            source: new Phaser.Geom.Rectangle(-275, -175, 550, 350),
            type: 'edge',
            quantity: 50
        };
        this.emitter.setEmitZone(this.emitZone);
        this.emitter.stop();
        this.add(this.emitter.manager);

        this.popupContainer = this.scene.add.container(0, 0);
        
        this.add(this.popupContainer);
       
        this.scene.addImage(0, 0, "popup_unlockstyle", this.popupContainer);
        const frameUp = (ABCyaLib.Environment.instance.gameConfig.subtitle === null) ? "BTN_okOff" : 'BTN_replayOff';
        const frameDown = (ABCyaLib.Environment.instance.gameConfig.subtitle === null) ? "BTN_okOn" : 'BTN_replayOn';
        this.okButton = this.scene.addButton(0, 130, frameUp, {frameOnDown: frameDown}, ()=>{
            this.hidePopup();
        }, this.popupContainer);
        this.snakeImage = this.scene.addImage(0, 0, Math.min(gameData.numUnlocked + 1, gameData.snakeTypes.length-1) + "_unlock", this.popupContainer);

        this.popupContainer.alpha = 0;
        this.popupContainer.setScale(1.5);
        this.overlay.alpha = 0;
    }

    displayPopup()
    {
      if(gameData.numUnlocked >= gameData.snakeTypes.length){
        this.emitter.tint.propertyValue = gameData.snakeTypes[gameData.snakeTypes.length-1].colors;
        this.snakeImage.setFrame(gameData.snakeTypes.length + "_unlock", false, false);
      } else {
        this.emitter.tint.propertyValue = gameData.snakeTypes[gameData.numUnlocked].colors;
        this.snakeImage.setFrame((gameData.numUnlocked + 1) + "_unlock", false, false);
      }

      this.scene.killTween(this.popupContainer);
      this.scene.killTween(this.overlay);

      this.popupContainer.setScale(1.5);

      this.scene.addTween(this.overlay, 300, {alpha: .4});
      this.scene.addTween(this.popupContainer, 300, {alpha: 1});
      this.scene.addTween(this.popupContainer, 1000, {scaleX: 1, scaleY: 1}, "Bounce");
      this.scene.addDelay(300, ()=>{
          this.emitter.explode(600);
          this.scene.addDelay(200, ()=>{
              this.emitter.explode(300);
              this.scene.addDelay(100, ()=>{
                  this.emitter.explode(150);
              });
          });
      });
    }

    hidePopup()
    {
        this.scene.killTween(this.popupContainer);
        this.scene.killTween(this.overlay);

        this.scene.addTween(this.popupContainer, 300, {alpha: 0, scaleX: 0, scaleY: 0});
        this.scene.addTween(this.overlay, 300, {alpha: 0});
    }
}